import { Content } from './actions-header.styled';

export const ActionsHeader = (props) => {
  const { children } = props;
  return <Content>{children}</Content>;
};

export default ActionsHeader;
